import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { DEMAND_KEYS, DEMAND_STATUS } from 'src/app/constant/pmkvy-constant';
import { CommonService } from 'projects/services/src/app/API/nsdccommonService/common.service';
import { BATCH_TRACK_STATUS } from 'projects/shared/src/app/shared/batch.table';
declare var toastr: any;
declare const swal;

@Component({
	selector: 'app-view-all-dap-candidates',
	templateUrl: './view-all-dap-candidates.component.html',
	styleUrls: ['./view-all-dap-candidates.component.css']
})
export class ViewAllDapCandidatesComponent implements OnInit {
	pageNo: any = 1;
	itemsPerPage: any = 10;
	length: any;
	count: any = 0;
	cancelBubble: boolean;
	candidateArray: any = [];
	selectStatus: boolean;
	modelObj: any = {
		subschemeId: '',
		candidateId: ''
	};
	schemesArray: any = [
		{
			name: 'RPL -III',
			value: '3'
		},
		{
			name: 'RPL - V',
			value: '5'
		},
	];
	statusArray: any = [{
		name: 'BATCH CREATED',
		value: 'batchCreated'
	}];
	fromDate: any;
	toDate: any;
	userMetaData: any = [];
	selectedBatches: any = [];
	statusColor = {
		'Demand Accepted': '#6EC014',
		'Demand Rejected': '#D0021B',
		'Demand Expired': '#D0021B',
		'Demand Raised': '#18D6B2'
	};

	// Phase 2 Changes
	listRadioButtonTab = DEMAND_KEYS;
	tabValue: any = this.listRadioButtonTab.jobRoleWise.value;
	extraBatchFieldToShow = false;

	tabList = {
		PENDING: { name: 'Pending', value: 'pending' },
		APPROVED: { name: 'Approved', value: 'approved' },
		REJECTED: { name: 'Rejected', value: 'rejected' },
	};
	activeTabValue = this.tabList.PENDING.value;
	demandStatusInPayload = DEMAND_STATUS.DEMAND_RAISED.value;

	IdOrAdharFailCandidates: any = [];
	EnrollCheckForOldData: any = [];
	enrollFailDueToDrpCnt: any = [];
	PWDJobRoleErrMsgsCheck: any = [];
	EnrolledOtherBatchInPastSixMonthBucket: any = [];
	enrollFailDueToEnrolCntBucket: any = [];
	NoAdharNoAltIdCandidatesCheck: any = [];
	BlockNameNotThereCandidate: any = [];
	GramPanchayatNotThereCandidate: any = [];
	ageNotEligibleCandidateCheck: any = [];
	religionNotEligibleCandidate: any = [];
	disabilityDocErrorCheck: any = [];
	RplRulesErrMsgsCheck: any = [];
	AdharFailCandidates: any = []
	failedCandidateForVoterPan: any = [];
	profilePictureRequired: any = [];
	trainedForSameQpBucket: any = [];
	SpRulesErrMsgsBucket: any = [];
	AdharOrBankDetailNotTherCheck: any = [];
	isMultipleBatchEnrollment: boolean;

	candidateDetails: any;
	batchDetails: any;
	isSchemeMoma = false;

	constructor(
		private currentUserservice: CurrentUserService,
		public location: Location,
		private commonservice: CommonService,
		private batchService: BatchService
	) { }

	ngOnInit() {
		this.currentUserservice.getCurrentUser().subscribe(loginuser => {
			console.log(loginuser);
			this.userMetaData = loginuser;
			this.getRplDapCandidates();
		});
	}

	assignPageNo(pageNo) {
		this.pageNo = pageNo;
		this.count = 0;
		this.selectStatus = false;
		this.getRplDapCandidates();
	}

	assignRecordsPerPage(perPage) {
		this.itemsPerPage = perPage;
		this.getRplDapCandidates();
	}

	checkIfAllSelected(param) {
		this.selectStatus = false;
		this.candidateArray.every(function (item: any) {
			console.log(item);
			return item.checked === true;
		});
		this.cancelBubble = false;
		this.count = 0;
		this.candidateArray.forEach(item => {
			if (item.checked) {
				this.count = this.count + 1;
				this.cancelBubble = true;
			}
		});
	}

	selectAll() {
		for (let i = 0; i < this.candidateArray.length; i++) {
			this.candidateArray[i].checked = this.selectStatus;
			console.log(this.candidateArray);
		}
		this.count = 0;
		this.cancelBubble = false;
		this.candidateArray.forEach(item => {
			if (item.checked) {
				this.count = this.count + 1;
				this.cancelBubble = true;
			}
		});

	}

	deSelectAll() {
		this.cancelBubble = false;
		this.count = 0;
		this.selectStatus = false;
		for (let i = 0; i < this.candidateArray.length; i++) {
			this.candidateArray[i].checked = false;
		}
		this.getRplDapCandidates();
	}

	getRplDapCandidates(filter?) {
		if (this.tabValue === this.listRadioButtonTab.jobRoleWise.value) {
			this.extraBatchFieldToShow = false;
		} else if (this.tabValue === this.listRadioButtonTab.batchWise.value) {
			this.extraBatchFieldToShow = true;
		}
		this.count = 0;
		let query = {
			'pageNo': this.pageNo,
			'limit': this.itemsPerPage,
			'demandStatus': this.demandStatusInPayload,
			'demand_type': this.tabValue
			// 'candidateId': this.userMetaData.userName
			// 'subschemeId': encodeURIComponent(this.tabStatus)
		}
		this.userMetaData.role === 'Training Partner' ? query['tpId'] = this.userMetaData.userName : query['tcId'] = this.userMetaData.userName;
		query = Object.assign({}, query, filter);
		this.commonservice.viewAllRaisedDemands(query).subscribe(res => {
			this.length = res.totalCount;
			if (res.result) {
				this.candidateArray = res.result;
				this.candidateArray.forEach((x, i) => {
					x['checked'] = false;
					this.candidateArray[i]['demandStatus'] = this.commonservice.getDemandStatus(x.demandStatus);
				})
			}
			else {
				this.candidateArray = []
			}
		}, err => {
			this.candidateArray = [];
		})
	}



	alignindividual(data, type) {
		let label = (type === 'Approved') ? 'DEMAND_ACCEPTED' : 'DEMAND_REJECTED';
		let payLoad = {
			'demandIds': [data.demandId],
			'demandStatus': label
		}
		this.commonservice.demandAction(payLoad).subscribe(res => {
			if (res[0].message === 'done') {
				swal(`Selected Candidate has been ${type}`, '', 'success').then(() => {
				});
			} else {
				swal(`${res[0].message}`, '', 'error').then(() => {
				});
			}
			this.getRplDapCandidates();
		})
	}
	alignBatch(type?) {
		let status: any;
		type ? status = 'DEMAND_ACCEPTED' : status = 'DEMAND_REJECTED'
		Helpers.copyArray(this.selectedBatches, []);
		if (this.count > 0) {
			if (!this.cancelBubble) {
				toastr.error('Select atleast one candidate to Accept');
				return;
			}
			for (let index = 0; index < this.candidateArray.length; index++) {
				if (this.candidateArray[index].checked) {
					this.selectedBatches.push(
						this.candidateArray[index].demandId,
					);
				}
			}
			if (this.count === 1) {
				this.commonservice.demandAction({
					'demandStatus': status,
					demandIds: this.selectedBatches
				}).subscribe(res => {
					swal(`Selected Candidate has been Accepted`, '', 'success').then(() => {
					});
					this.getRplDapCandidates();
					this.selectStatus = false;
				})
			}
			if (this.count > 1) {
				this.commonservice.demandAction({ 'demandStatus': status, demandIds: this.selectedBatches }).subscribe(res => {
					swal(`Selected Candidates have been Accepted`, '', 'success').then(() => {
					});
					this.getRplDapCandidates();
					this.selectStatus = false
				})
			}
		} else {
			toastr.error('Please select atleast one Candidate to Accept');
		}

	}

	applyFilter() {
		console.log(this.modelObj);
		this.getRplDapCandidates(this.modelObj);
	}

	resetFilter() {
		this.modelObj.subschemeId = '';
		this.modelObj.candidateId = '';
		this.getRplDapCandidates();
	}

	selectTab(tab) {
		if (this.activeTabValue !== tab) {
			this.activeTabValue = tab;
			switch (tab) {
				case this.tabList.PENDING.value:
					this.demandStatusInPayload = DEMAND_STATUS.DEMAND_RAISED.value;
					break;
				case this.tabList.APPROVED.value:
					this.demandStatusInPayload = DEMAND_STATUS.DEMAND_ACCEPTED.value;
					break;
				case this.tabList.REJECTED.value:
					this.demandStatusInPayload = DEMAND_STATUS.DEMAND_REJECTED.value;
					break;
				default:
					break;
			};
			this.pageNo = 1;
			this.itemsPerPage = 10;
			this.getRplDapCandidates();
		}
	}

	enroll(data) {
		this.batchService.enrollCandidate(
			// this.mapPayLoad(),
			data,
			data.batch.batchId,
			this.userMetaData.userName,
			false
		).subscribe(res => {

			})
	}

	getSn(index): number {
		return Helpers.getSno(index, this.pageNo, this.itemsPerPage);
	}

	enrollmentCheck(data) {
		if (data && data.candidateId) {
			this.batchService.candidateDetails(data.candidateId).subscribe(
				canRes => {
					this.candidateDetails = canRes;
					this.candidateDetails['boardingLodging'] = canRes.boardingLodging ? true : false;
					this.batchService.ValidateCandidatesEnroll(
						data.batch.batchId,
						data.trainingPartner.userName,
						[{
							userName: data.candidateId,
							candidateID: data.candidateId,
							firstName: this.candidateDetails.personalDetails.firstName || ''
						}]
					).subscribe(res => {
						this.IdOrAdharFailCandidates = res.IdOrAdharFailCandidates || [];
						this.EnrollCheckForOldData = res.EnrollCheckForOldData || [];
						this.enrollFailDueToDrpCnt = res.enrollFailDueToDrpCnt || [];
						this.AdharFailCandidates = res.AdharFailCandidates || [];
						this.profilePictureRequired = res.ProfilPicNotThereCandidate || [];
						this.failedCandidateForVoterPan = res.EnrollFailDueToVoterAndPan || [];
						this.trainedForSameQpBucket = res.trainedForSameQp || [];
						this.SpRulesErrMsgsBucket = res.SpRulesErrMsgs || [];
						this.PWDJobRoleErrMsgsCheck = res.PWDJobRoleErrMsgs || [];
						this.enrollFailDueToEnrolCntBucket = res.enrollFailDueToEnrolCnt || [];
						this.disabilityDocErrorCheck = res.DisabilityDocError || [];
						this.ageNotEligibleCandidateCheck = res.AgeNotEligibleCandidate || [];
						this.religionNotEligibleCandidate = res.ReligionNotEligibleCandidate || [];
						this.BlockNameNotThereCandidate = res.BlockNameNotThereCandidate || [];
						this.GramPanchayatNotThereCandidate = res.GramPanchayatNotThereCandidate || [];
						// if (this.schemeType === 'SP' || this.schemeType === 'RPL') {
						// 	this.AdharOrBankDetailNotTherCheck = [];
						// } else {
							this.AdharOrBankDetailNotTherCheck = res.AdharOrBankDetailNotTher || [];
						// }

						this.NoAdharNoAltIdCandidatesCheck = res.NoAdharNoAltIdCandidates || [];
						this.RplRulesErrMsgsCheck = res.RplRulesErrMsgs;
						this.batchService.isMultipleBatchEnroll().subscribe(multires => {
							console.log(this.isMultipleBatchEnrollment);

							this.isMultipleBatchEnrollment = multires;
							if (this.isMultipleBatchEnrollment) {
								this.EnrolledOtherBatchInPastSixMonthBucket = [];
								this.trainedForSameQpBucket = [];
								this.EnrollCheckForOldData = [];
								// this.profilePictureRequired = [];
								this.PWDJobRoleErrMsgsCheck = [];
								this.disabilityDocErrorCheck = [];
								this.SpRulesErrMsgsBucket = [];
								this.RplRulesErrMsgsCheck = [];
							} else {
								this.trainedForSameQpBucket = res.trainedForSameQp || [];
								this.EnrolledOtherBatchInPastSixMonthBucket = res.EnrolledOtherBatchInPastSixMonth || [];
							}
							if (this.EnrollCheckForOldData.length > 0 ||
								this.failedCandidateForVoterPan.length > 0 ||
								this.IdOrAdharFailCandidates.length > 0 ||
								this.AdharFailCandidates.length > 0 ||
								this.profilePictureRequired.length ||
								this.trainedForSameQpBucket.length > 0 ||
								this.EnrolledOtherBatchInPastSixMonthBucket.length > 0 ||
								this.SpRulesErrMsgsBucket.length > 0 ||
								this.PWDJobRoleErrMsgsCheck.length > 0 ||
								this.enrollFailDueToEnrolCntBucket.length > 0 ||
								this.disabilityDocErrorCheck.length > 0 ||
								this.AdharOrBankDetailNotTherCheck.length > 0 ||
								this.NoAdharNoAltIdCandidatesCheck.length > 0 ||
								this.RplRulesErrMsgsCheck.length > 0
							) {
								Helpers.openModal('IdOrAdharFailCandidatesModal')
								return;

							} else {
								this.enrollCandidate(data);
							}
						})
					});
				}
			)
		}

	}
	enrollCandidate(data) {
		if (data && data.batch &&
			(data.batch.Batch_status === BATCH_TRACK_STATUS.BATCH_CREATED.value ||
				data.batch.Batch_status === BATCH_TRACK_STATUS.BATCH_CANDIDATE_ENROLLED.value)) {
			this.batchService.getFeeBasedBatchDetails(
				data.batch.batchId
			).subscribe(res => {
				this.batchDetails = res;
				if (res && res.candidates && res.candidates.length) {
					const canIdx = res.candidates.findIndex(can => can.userName === data.candidateId);
					if (canIdx === -1) {
						this.finalEnroll(data);
					} else {
						this.commonservice.successSwal('Already Enrolled in the batch', 'error')
					}
				} else {
					this.finalEnroll(data);
				}
			})
		}
	}

	finalEnroll(data, candidateData?) {
		swal({
			title: `Are you sure, you want to enroll the selected ${data.candidateId} candidates`,
			text: 'You cannot enroll any candidates further in the batch after submission of candidate enrollment.',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, I am sure'
		}).then(result => {
			if (result.value) {
				this.batchService.enrollCandidate(
					this.mapCandidatePayload(),
					data.batch.batchId,
					(this.userMetaData.role === 'Training Partner') ? this.userMetaData.userName : this.userMetaData.trainingPartner.userName,
					false).subscribe(res => {
						if (res) {
							this.commonservice.successSwal(`${data.candidateId} Enrolled Successfully`, 'success')
						}
					})
			}
		})
	}

	closeCandidateErrorModal() {
		Helpers.closeModal('IdOrAdharFailCandidatesModal');
	}

	mapCandidatePayload() {
		return {
			candidates: [
				{
					selected: true,
					id: this.candidateDetails.userName,
					candidateID: this.candidateDetails.userName,
					userName: this.candidateDetails.userName,
					createdBy: this.candidateDetails.createdBy,
					userRole: '',
					idType: this.candidateDetails.personalDetails.idType,
					firstName: this.candidateDetails.personalDetails.firstName,
					name: this.candidateDetails.personalDetails.firstName,
					email: this.candidateDetails.contactDetails.email,
					phone: this.candidateDetails.contactDetails.phone,
					bnlEl: false,
					conveyanceEl: false,
					hasFullyReg: this.candidateDetails.hasFullyReg,
					bankDetails: {
						accountHolderName: this.candidateDetails.bankDetails.accountHolderName,
						bankName: this.candidateDetails.bankDetails.bankName,
						accountNumber: this.candidateDetails.bankDetails.accountNumber,
						ifscCode: this.candidateDetails.bankDetails.ifscCode,
						bankAddress: this.candidateDetails.bankDetails.bankAddress
					},
					pwdEl: false,
					transportEl: false,
					gender: this.candidateDetails.personalDetails.gender,
					state: this.candidateDetails.contactDetails.permanentAddress.state,
					religion: this.candidateDetails.personalDetails.religion,
					district: this.candidateDetails.contactDetails.permanentAddress.districtDetails.district,
					sourceMob: this.candidateDetails.sourceOfMobilization.source,
					differentlyAbled: this.candidateDetails.personalDetails.differentlyAbled,
					disabilityCategory: this.candidateDetails.personalDetails.disabilityCategory,
					isCertified: false,
					AlternateIdType: this.candidateDetails.personalDetails.alternateIdType,
					AlternateIDNumber:  this.candidateDetails.personalDetails.alternateIdNumber,
					trainingDetails: this.batchDetails.trainingDetails,
					isAlternateIdVerfied: this.candidateDetails.personalDetails.isAlternateIdVerfied ? 'Yes' : 'No',
					AadharRefID: this.candidateDetails.personalDetails.aadhar.aadhaarRef || '',
					jobRole: this.batchDetails.jobRole,
					status: this.batchDetails.status,
					isDropped: false,
					bnlMode: null,
					conveyanceOpted: true,
					bnlOpted: null,
					pwdEligibility: false,
					bnlEligibility: false,
					transportEligibility: false,
					conveyanceEligible: false
				}
			]
		}
	}

}

